import { Component, inject } from '@angular/core';
import { ModalWindowService } from '@bci-web-core/core';
import { OperationHelpComponent } from './../operation-help/operation-help.component';


@Component({
    selector: 'app-help-menu',
    templateUrl: './help-menu.component.html',
    styleUrls: ['./help-menu.component.scss'],
    standalone: false
})
export class HelpMenuComponent {
  private modalWindowService = inject(ModalWindowService);

  onOperationHelp() {
    this.modalWindowService.openDialogWithComponent(OperationHelpComponent, { width: '1100px' });
  }
}

